import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.bonusProcessingTransactions
)

export const selectBonusProcessingTransactionsError = createSelector(
    baseSelector,
    (state) => state.error
)
export const selectBonusProcessingTransactions = createSelector(
    baseSelector,
    (state) => state.transactions
)
export const selectBonusProcessingTransactionsLoading = createSelector(
    baseSelector,
    (state) => state.isLoading
)
export const selectBonusProcessingTransactionsFirstLoad = createSelector(
    baseSelector,
    (state) => state.isFirstLoad
)
export const selectBonusProcessingTransactionsCurrentPage = createSelector(
    baseSelector,
    (state) => state.page
)
export const selectBonusProcessingTransactionsStartDate = createSelector(
    baseSelector,
    (state) => state.startDate
)
export const selectBonusProcessingTransactionsEndDate = createSelector(
    baseSelector,
    (state) => state.endDate
)
export const selectBonusProcessingTransactionsBonus = createSelector(
    baseSelector,
    (state) => state.bonusId
)
export const selectBonusProcessingTransactionsWithAccrual = createSelector(
    baseSelector,
    (state) => state.withAccrual
)
